<div class="page-wrapper" [ngClass]="show ? 'toggled' : ''">

  <!-- sidebar-wrapper -->
  <app-admin-sidebar/>
  <!-- sidebar-wrapper  -->

  <!-- Start Page Content -->
  <main class="page-content bg-gray-50 dark:bg-slate-800">
    <!-- Top Header -->
    <app-admin-navbar (showChange)="updateShow($event)"/>
    <!-- Top Header -->
    <ng-content></ng-content>
    <!-- Footer Start -->
    <footer class="shadow dark:shadow-gray-700 bg-white dark:bg-slate-900 px-6 py-4">
      <div class="container-fluid">
        <div class="grid grid-cols-1">
          <div class="sm:text-start text-center mx-md-2">
            <p class="mb-0 text-slate-400">© {{year}} Giglink. Design with <i class="mdi mdi-heart text-red-600"></i> by <a href="https://shreethemes.in/" target="_blank" class="text-reset">Shreethemes</a>. {{ `Version: ${version}` }}</p>
          </div><!--end col-->
        </div><!--end grid-->
      </div><!--end container-->
    </footer><!--end footer-->
    <!-- End -->
  </main>
  <!--End page-content" -->
</div>
